import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { DELETE_NOISE_WAVE, DELETE_WAVE } from '../analytics.constants';
import { CommonInteraction } from '../types/analytics.types';
import { Wave } from '../../wave/types/wave.type';

export const trackDeleteWave =
  (
    wave: Wave,
    interaction: CommonInteraction,
    analyticsEventTrack = track,
  ): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    if (wave.type === 'P' || wave.type === 'QRS' || wave.type === 'T') {
      const waveType = wave?.link ? 'QRS+T' : wave.type;
      analyticsEventTrack({
        name: DELETE_WAVE,
        properties: {
          ecg_id: ecgId,
          view,
          wave: waveType,
          user_id: userId,
          interaction,
        },
      });
    } else {
      analyticsEventTrack({
        name: DELETE_NOISE_WAVE,
        properties: {
          ecg_id: ecgId,
          view,
          wave: wave.type,
          user_id: userId,
          interaction,
        },
      });
    }
  };
